import { render, staticRenderFns } from "./BoardReply.vue?vue&type=template&id=3334059a&scoped=true&"
import script from "./BoardReply.vue?vue&type=script&lang=js&"
export * from "./BoardReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334059a",
  null
  
)

export default component.exports